import { Link } from 'react-router-dom';

export default function Contact() {
  return (
    <div style={S.page}>
      <div style={S.container}>
        <Link to="/" style={S.back}>← Back to Candid</Link>

        <h1 style={S.h1}>Get in touch</h1>
        <p style={S.lead}>Have a question, report, or feedback? We'd love to hear from you.</p>

        <div style={S.card}>
          <div style={S.cardLabel}>Email</div>
          <a href="mailto:justcandid.app@gmail.com" style={S.cardEmail}>justcandid.app@gmail.com</a>
          <p style={S.cardNote}>We aim to respond within 2 business days.</p>
        </div>

        <div style={S.section}>
          <h2 style={S.h2}>What kind of question?</h2>
          <ul style={S.ul}>
            <li><strong>Waitlist help</strong> — joining, removing your email, or updating your info</li>
            <li><strong>Safety</strong> — concerns or feedback about safety, especially as we prepare to launch</li>
            <li><strong>Privacy & data</strong> — questions about what we collect or to request your data</li>
            <li><strong>Press & partnerships</strong> — media inquiries or partnership opportunities</li>
            <li><strong>Feedback</strong> — ideas, bugs, or anything else</li>
          </ul>
        </div>

        <div style={S.section}>
          <h2 style={S.h2}>Legal</h2>
          <p>
            See our <Link to="/privacy" style={S.link}>Privacy Policy</Link> and <Link to="/terms" style={S.link}>Terms of Service</Link>.
          </p>
        </div>
      </div>
    </div>
  );
}

const S = {
  page: { minHeight: '100vh', background: '#030010', color: '#e5e5e5', fontFamily: 'system-ui, -apple-system, sans-serif', padding: '40px 20px' },
  container: { maxWidth: 720, margin: '0 auto' },
  back: { color: '#a78bfa', textDecoration: 'none', fontSize: 13, fontWeight: 600, marginBottom: 32, display: 'inline-block' },
  h1: { fontSize: 36, fontWeight: 900, letterSpacing: -1.5, marginTop: 24, marginBottom: 12, background: 'linear-gradient(90deg, #a78bfa, #f472b6, #fb923c)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' },
  lead: { fontSize: 16, color: '#bbb', lineHeight: 1.6, marginBottom: 32 },
  card: { background: 'rgba(167,139,250,0.06)', border: '1px solid rgba(167,139,250,0.18)', borderRadius: 16, padding: 28, marginBottom: 40 },
  cardLabel: { fontSize: 11, color: '#888', letterSpacing: 1.5, textTransform: 'uppercase', marginBottom: 8 },
  cardEmail: { color: '#a78bfa', fontSize: 22, fontWeight: 700, textDecoration: 'none', display: 'inline-block', marginBottom: 12 },
  cardNote: { fontSize: 13, color: '#888', lineHeight: 1.6, margin: 0 },
  section: { marginBottom: 32 },
  h2: { fontSize: 18, fontWeight: 800, marginBottom: 12, color: '#fff' },
  ul: { color: '#bbb', paddingLeft: 22, lineHeight: 1.8, margin: 0 },
  link: { color: '#a78bfa' },
};
